import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsertVideo = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.1679 11.6117C14.1834 12.0838 14.3987 12.5282 14.7617 12.8332L15.595 13.5332C16.6793 14.444 18.3337 13.6732 18.3337 12.257V7.74363C18.3337 6.32751 16.6793 5.55662 15.595 6.46746L14.7617 7.16746C14.4003 7.471 14.1853 7.91281 14.1681 8.38249M14.1679 11.6117L14.167 12.5003C14.167 14.3412 12.6746 15.8337 10.8337 15.8337H5.00033C3.15938 15.8337 1.66699 14.3412 1.66699 12.5003V7.50033C1.66699 5.65938 3.15938 4.16699 5.00033 4.16699H10.8337C12.6746 4.16699 14.167 5.65938 14.167 7.50033L14.1681 8.38249M14.1679 11.6117L14.1681 8.38249",
		stroke: "#71717A",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgInsertVideo);
export default ForwardRef;
